import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiErrorMessage } from '../utils/errors';
import Icon from './Icon';

const ResetPassword: React.FC = () => {
  const { confirmPasswordReset } = useAuth();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid') || '';
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await confirmPasswordReset(uid, token, newPassword);
    } catch (err) {
      setError(apiErrorMessage(err, 'This password reset link is invalid or has expired.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1 className="login-logo">
          <Icon name="pan" className="icon" /> RecipeEngine
        </h1>
        <p className="login-tagline">Choose a new password</p>

        {!uid || !token ? (
          <div className="login-error">This password reset link is missing or malformed.</div>
        ) : (
          <>
            {error && <div className="login-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="new-password">New password</label>
              <input
                id="new-password"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoFocus
                required
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={submitting} style={{ width: '100%' }}>
                {submitting ? 'Saving...' : 'Save new password'}
              </button>
            </div>
          </>
        )}

        <p className="login-tagline" style={{ margin: 0 }}>
          <Link to="/forgot-password">Request a new link</Link> · <Link to="/">Back to sign in</Link>
        </p>
      </form>
    </div>
  );
};

export default ResetPassword;
